import CalendarI18n from "../utils/CalendarI18n";
import {DceJsx, DceJsxRenderer} from "../../../../../dce-jsx"
import CalendarMonth from "../utils/CalendarMonth";
import MonthRenderer from "./MonthRenderer";
import Calendar from "../Calendar";

export default class CalendarRenderer extends DceJsxRenderer {

    private currentMonth: CalendarMonth;

    private calendarMonthHeight = 100;

    private renderedMonths: RenderedMonth[] = [];
    private cacheMonths: number;

    private animationFrameCallbackNumber: any;

    private i18n: CalendarI18n;

    private mondayStart: boolean;

    private _monthName: HTMLElement;
    private _yearName: HTMLElement;

    private _months: HTMLElement;
    private _monthsScrollable: HTMLElement;
    private _monthsContainer: HTMLElement;

    constructor(mondayStart: boolean, cacheMonths: number, elem: HTMLElement, startMonth: CalendarMonth) {
        super();
        this.cacheMonths = cacheMonths;
        this.mondayStart = mondayStart;
        this.i18n = CalendarI18n.getInstance();

        console.log("CASHE MONTHS", this.cacheMonths);

        this.currentMonth = startMonth

        this.fill(elem);

        this.changeMonth(this.currentMonth);

        this.setupScroll();

        this.monthsScrollable.addEventListener('scroll', e => {

            let st = (e.target as HTMLElement).scrollTop;
            if(null != this.animationFrameCallbackNumber){
                cancelAnimationFrame(this.animationFrameCallbackNumber);
            }

            this.animationFrameCallbackNumber = requestAnimationFrame(() => {
                this.renderCurrentOnScroll(st);
            });

        });
    }

    private renderCurrentOnScroll(scrollTop: number): void {
        this.animationFrameCallbackNumber = null;

        let cent = this.currentMonth.monthsFromCentury();

        let displayMonth = Math.floor((scrollTop) / this.calendarMonthHeight);

        let diff = displayMonth - this.currentMonth.monthsFromCentury();
        if (0 != diff) {
            this.changeMonth(CalendarMonth.fromCenturyMonth(displayMonth));
        }

    }

    private changeMonth(m: CalendarMonth) {
        let newmonths = this.generateMonths(m);
        this.updateMonths(newmonths);
        this.currentMonth = m;
        this.updateLabel();
    }

    private updateLabel(){
        this.monthName.innerText = this.i18n.month(this.currentMonth);
        this.yearName.innerText = this.currentMonth.year + "";
    }

    private clearMonths() {
        this.renderedMonths.forEach(e => {
            e.element.remove();
        });
        this.renderedMonths = [];
    }

    private generateMonths(centerMonth: CalendarMonth): CalendarMonth[] {

        let start = -1 * this.cacheMonths;
        let end = 1 + this.cacheMonths;

        console.log(start, end);

        let months: CalendarMonth[] = [];
        for (let i = start; i < end; i++) {
            months.push(
                centerMonth.plusMonths(i)
            )
        }

        console.log("m", months);
        return months;
    }

    private createMonthRenderer(m: CalendarMonth): MonthRenderer{
        let v = new MonthRenderer(m, Calendar.NOW, this.mondayStart)
        v.onDayClick = (month, day, elem) => {this.dayClick(month, day, elem)};
        return v;
    }

    private dayClick(month: CalendarMonth, day: number, elem: HTMLElement){
        this.months.querySelectorAll('span.selected').forEach(e => {

            if(e != elem){
                e.classList.remove('selected');
            }
        });

    }

    private updateMonths(months: CalendarMonth[]) {
        //initial update
        if (this.renderedMonths.length == 0) {

            months.forEach(m => {
                let renderer = this.createMonthRenderer(m);
                let elem = renderer.appendTo(this.months);

                this.renderedMonths.push({
                    id: m.monthsFromCentury(),
                    element: elem
                });
            })

            return;
        }

        let newMonths: number[] = months.map(a => a.monthsFromCentury());

        //usuwamy miesiace
        let filtered = this.renderedMonths.filter(v => {
            if (newMonths.indexOf(v.id) == -1) {
                v.element.remove();
                return false;
            }
            return true;
        });

        //mapa poprzednich miesiecy
        let oldMonths: Map<number, RenderedMonth> = new Map();
        filtered.forEach(v => {
            oldMonths.set(v.id, v);
        })

        let newRendered: RenderedMonth[] = [];

        for (let i = 0; i < months.length; i++) {

            let m = months[i];
            let id = m.monthsFromCentury();

            if (oldMonths.has(id)) {
                newRendered.push(oldMonths.get(id))
            } else {
                //nowy miesiac
                let mr = this.createMonthRenderer(m); //new MonthRenderer(m, Calendar.NOW, this.mondayStart);

                let elem;
                if (i > 0) {
                    elem = mr.insertAfter(newRendered[i - 1].element);

                } else {
                    elem = mr.prependTo(this.months);
                }

                newRendered.push({
                    id: id,
                    element: elem
                });

            }
        }

        this.renderedMonths = newRendered;

        this.setCalendarTranslate(months[0]);

    }


    private setupScroll() {

        let monthhBody = this.months.querySelector('tbody');

        this.calendarMonthHeight = monthhBody.offsetHeight;
        this.monthsScrollable.style.height = (this.calendarMonthHeight + 10) + 'px';

        console.log("MONTH HEIGHT", this.calendarMonthHeight);

        let scrollheight = 200 * 12 * this.calendarMonthHeight;

        let hkeeper = document.createElement('div');
        hkeeper.style.width = '1px';
        hkeeper.style.position = 'absolute';
        hkeeper.style.top = '0px'
        hkeeper.style.left = '0px';
        hkeeper.style.height = scrollheight + 'px';

        this.monthsScrollable.append(hkeeper);

        //tutaj zaczynamy
        let startMonth = this.currentMonth.minusMonths(3);
        this.setCalendarTranslate(startMonth);

        let nameHeight = ((monthhBody.querySelector('tr')) as HTMLElement).offsetHeight;

        console.log("NAME HEIGHT", nameHeight);

        this.monthsScrollable.scrollTop = (this.currentMonth.monthsFromCentury() * this.calendarMonthHeight) + nameHeight + 10;

        console.log("MONTH start scroll top", this.monthsScrollable.scrollTop);

    }

    private setCalendarTranslate(month: CalendarMonth) {
        //console.log("Start month to translate: " + CalendarI18n.monthName(month));
        this.monthsContainer.style.transform = 'translateY(' + (month.monthsFromCentury() * this.calendarMonthHeight) + 'px)';
    }

    public bindByRef(ref: String, elem: HTMLElement) {

        if (ref == 'month-name') {
            this._monthName = elem;
        }

        if (ref == 'year-name') {
            this._yearName = elem;
        }

        if (ref == 'months') {
            this._months = elem;
        }

        if (ref == 'months-scrollable') {
            this._monthsScrollable = elem;
        }

        if (ref == 'months-container') {
            this._monthsContainer = elem;
        }
    }

    get monthsContainer(): HTMLElement {
        return this._monthsContainer;
    }

    get monthsScrollable(): HTMLElement {
        return this._monthsScrollable;
    }

    get monthName(): HTMLElement {
        return this._monthName;
    }

    get months(): HTMLElement {
        return this._months;
    }

    get yearName(): HTMLElement {
        return this._yearName;
    }





    render(): JSX.Element {

        let days = CalendarI18n.getInstance().weekdaysShort();

        if (!this.mondayStart) {
            let su = days.pop();
            days.unshift(su);
        }

        return (
            <div className="dce-calendar">
                <div className="dce-calendar-header">
                    <div className="dce-calendar-header-month" >
                        <span ref="month-name"></span> <span ref="year-name"></span>
                    </div>
                    <div className="dce-calendar-nav">
                        <span className={"dce-fullcalendar-nav-up"}></span>
                        <span className={"dce-fullcalendar-nav-down"}></span>
                    </div>
                </div>

                <div className="dce-calendar-header-weekdays">
                    <table>
                        <colgroup>
                            <col/>
                            <col/>
                            <col/>
                            <col/>
                            <col/>
                            <col/>
                            <col/>
                        </colgroup>
                        <tr>
                            {
                                days.map(d => {
                                    return <th>{d}</th>
                                })
                            }
                        </tr>
                    </table>

                    <div className="dce-calendar-scrollable" ref="months-scrollable">
                        <div className="dce-calendar-table" ref="months-container">
                            <table ref="months">
                                <colgroup>
                                    <col/>
                                    <col/>
                                    <col/>
                                    <col/>
                                    <col/>
                                    <col/>
                                    <col/>
                                </colgroup>

                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

interface RenderedMonth {
    id: number;
    element: HTMLElement;
}